import { render, staticRenderFns } from "./social_xp.vue?vue&type=template&id=7272bbf1&"
import script from "./social_xp.vue?vue&type=script&lang=js&"
export * from "./social_xp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports